import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { getDetail } from "./thunks/get-detail";
import { listAddresses } from "./thunks/list-addresses";
import { listAmbassadors } from "./thunks/list-ambassadors";
import { listReports } from "./thunks/list-reports";
import { reassign } from "./thunks/reassign";
import { reschedule } from "./thunks/reschedule";

const name = "supervisorDelivery";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDetail.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(getDetail.fulfilled, (state, action) => {
        state.delivery = action.payload;
        state.isPending = false;
      })
      .addCase(getDetail.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(listAmbassadors.fulfilled, (state, action) => {
        state.ambassadors = action.payload;
      })
      .addCase(listReports.fulfilled, (state, action) => {
        state.reports = action.payload;
      })
      .addCase(listAddresses.fulfilled, (state, action) => {
        state.addresses = action.payload;
      });

    for (const thunk of [reassign, reschedule]) {
      builder
        .addCase(thunk.pending, (state) => {
          state.isActing = true;
          state.actionError = "";
        })
        .addCase(thunk.fulfilled, (state) => {
          state.isActing = false;
        })
        .addCase(thunk.rejected, (state, action) => {
          state.isActing = false;
          state.actionError = action.error.message ?? "";
        });
    }
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
